import { useEffect } from 'react';

declare global {
  interface Window {
    $crisp: any[];
    CRISP_WEBSITE_ID: string;
  }
}

export default function LiveChat() {
  useEffect(() => {
    if (window.location.pathname.startsWith('/admin')) return;
    if (window.$crisp) return;

    window.$crisp = [];
    window.CRISP_WEBSITE_ID = '54f6d31d-3003-4f65-904f-1ef2d3920950';

    const script = document.createElement('script');
    script.src = 'https://client.crisp.chat/l.js';
    script.async = true;
    document.getElementsByTagName('head')[0].appendChild(script);

    return () => {
      try { window.$crisp?.push(['do', 'chat:hide']); } catch {}
    };
  }, []);

  return null;
}

